import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import { LangConstant } from "const";
import { Pagination } from "components";
import dayjs from "dayjs";

const SystemErrorTable = ({ limitation, page, setPage, branchErrors, isLoading }) => {
  const { t: getLabel } = useTranslation();

  const tableErrorObj = getLabel(LangConstant.OBJ_TABLE_ERROR, { returnObjects: true });

  const tableHeaderField = [
    { label: tableErrorObj.number, width: "10%" },
    { label: tableErrorObj.errorFeature, width: "20%" },
    { label: tableErrorObj.errorComponent, width: "20%" },
    { label: tableErrorObj.time, width: "15%" },
    { label: tableErrorObj.description, width: "35%" },
  ];

  const handlePageChange = (_, newPage) => {
    setPage(newPage);
  };

  const handleConvertTime = timestamp => {
    try {
      return dayjs(timestamp).format("DD/MM/YYYY HH:mm");
    } catch (error) {
      return "";
    }
  };

  const totalPages = Math.ceil(branchErrors.totalElements / limitation);

  return (
    <div>
      <div className="card" >
        <div className="table-responsive">
          <table className="table table-vcenter">
            <thead>
              <tr>
                {tableHeaderField.map(item => (
                  <th key={item.label} style={{ width: item.width, fontWeight: "bold", fontSize: 14 }}>
                    {item.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan={5} className="text-center">
                    <div className="d-flex align-items-center justify-content-center gap-2 py-3">
                      <span className="spinner-border spinner-border-sm text-primary"></span>
                      <small>{getLabel(LangConstant.TXT_LOADING)}</small>
                    </div>
                  </td>
                </tr>
              ) : branchErrors.data && branchErrors.data.length > 0 ? (
                branchErrors.data.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td style={{ fontSize: 14 }}>{(page - 1) * limitation + (index + 1)}</td>
                      <td style={{ fontSize: 14 }}>{item.error_name}</td>
                      <td style={{ fontSize: 14 }}>{item.component_name}</td>
                      <td style={{ fontSize: 14 }}>{handleConvertTime(item.created)}</td>
                      <td style={{ fontSize: 14 }}>{item.description}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={5} className="text-center">
                    <small>
                      <i>{getLabel(LangConstant.TXT_NOT_FOUND)}</i>
                    </small>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      {totalPages > 1 && (
        <Pagination currentPage={page} totalPages={totalPages} onPageChange={handlePageChange} />
      )}
    </div>
  );
};

export default memo(SystemErrorTable);
